/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

  getPermissions: state => {
    return state.permissions
  },

  getFirstChildren: state => {
    return state.childrenFirst
  },
  getSecondChildren: state => {
    return state.childrenSecond
  },
  getThirdChildren: state => {
    return state.childrenThird
  },
  getFourthChildren: state => {
    return state.childrenFourth
  },
  getFifthChildren: state => {
    return state.childrenFifth
  },
  getSixthChildren: state => {
    return state.childrenSixth
  },
  getSevenChildren: state => {
    return state.childrenSeven
  },
  getEightChildren: state => {
    return state.childrenEight
  },
  getRoles: state => {
    return state.roles
  },
  getUsers: state => {
    return state.users
  }
}
